module.exports = __webpack_public_path__ + "static/media/macif.895967c7.svg";